export default __webpack_public_path__ + "static/about-logo-d691b5f6f20399ccd7db8679d88aa6d3.png";